// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customContainer[data-v-31b437e0] {\n  min-height: --webkit-fill-available;\n  height: 100%;\n  overflow-y: visible !important;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
